import React from 'react'
import { TransactionDetails as TransactionDetailsComp } from '@bet25/ui'
import { ModalService } from 'services/ModalService'

const TransactionDetails = (props) => {
    return (
        <TransactionDetailsComp
            currentTheme={'dark'}
            data={props.data}
            onClose={() => ModalService.closeModal('TRANSACTION_INFO')}
        />
    )
}
export default TransactionDetails
